// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jTvpS","type":"styles_type__2xsSv","choices":"styles_choices__3BVj5"};